import React from "react";
import "./regHeader.css";
import { EMAIL_HEADER } from "../../constants/constants";
import useGetEventSettings from "../hooks/useGetEventSettings";
import { LinearProgress } from "@mui/material";
const RegHeader = () => {
  const { data, isLoading, isError } = useGetEventSettings();
  if (isLoading) {
    return <LinearProgress />;
  }
  return (
    <a href="https://www.imtex.in/" target="_blank">
      <div
        className="newhcontainer"
        style={{
          backgroundImage: `url(${"https://imtex2024-imtma.expoplanner.in/static/media/header_bg.780c40d922984ce51348.png"})`,
        }}
      >
        <img
          style={{ height: "100%" }}
          className="newhheader-image"
          src={data?.emailTemplate?.headerUrl}
          alt="App Header"
        />
      </div>
    </a>
  );
};

export default RegHeader;
